import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ICustomerUpdateLeadResponse } from "../models/Customer";

export default function useCustomerUpload() {
  const { customerPostFormData, customerPatch } = useApiHelper();
  const queryClient = useQueryClient();

  const uploadDocs = useMutation(
    (body: any) => customerPostFormData(`/customer/documents/${body.leadId}`, body),
    {
      onSuccess: () => {
      },
    }
  );

  const updateLead = useMutation<ICustomerUpdateLeadResponse, Error, Record<string, unknown>>(
    (body) => customerPatch<ICustomerUpdateLeadResponse>(`/customer/lead/${body.leadId}`, body),
    {
      onSuccess: () => {
      },
    }
  );

  return {
    uploadDocs,
    updateLead,
  };
}
